import { Outlet } from 'react-router';

import { Footer } from '../footer';

import { ReactComponent as LogoImg } from 'assets/images/brand-img.svg';

import styles from './styles.module.scss';

export const Login = () => {
	return (
		<div className={styles.layoutWrapper}>
			<section className={styles.login}>
				<Outlet />

				{/* <div className={styles.login__image}>
					<LogoImg />
				</div> */}
			</section>

			<Footer />
		</div>
	);
};
